import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import ImageCarousel from './ImageCarousel';
import brushMain from '../assets/images/IMG_6449.jpg';
import brushAltOne from '../assets/images/IMG_5290.JPG';
import brushAltTwo from '../assets/images/IMG_5289.JPG';
import detailImageOne from '../assets/images/IMG_8638.JPG';
import detailImageTwo from '../assets/images/IMG_8335.JPG';
import detailImageThree from '../assets/images/IMG_8334.JPG';
import detailImageFour from '../assets/images/IMG_7742.JPG';
import detailImageFive from '../assets/images/IMG_5292.JPG';
import detailImageSix from '../assets/images/IMG_7741.JPG';

const BrushSetDetails = () => {
  const { t } = useLanguage();
  const setContents = t.setContents || {};
  const items = setContents.items || [];
  const images = [
    brushMain,
    brushAltOne,
    brushAltTwo,
    detailImageOne,
    detailImageTwo,
    detailImageThree,
    detailImageFour,
    detailImageFive,
    detailImageSix,
  ];

  return (
    <section className="relative w-full overflow-hidden bg-[#ffe7f1]" aria-labelledby="set-contents-title">
      <div className="absolute inset-0 -z-10">
        <div className="absolute -top-24 right-0 h-64 w-64 rounded-full bg-[#ffd6e6] blur-3xl opacity-70" />
        <div className="absolute bottom-8 left-[-3rem] h-56 w-56 rounded-full bg-[#fff1f7] blur-2xl opacity-80" />
      </div>

      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 py-8 lg:py-10">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12">
          <div className="rounded-3xl border border-[#f2bfd4] bg-white/80 p-6 sm:p-8 shadow-[0_18px_40px_-28px_rgba(226,76,139,0.6)]">
            <h2
              id="set-contents-title"
              className="text-2xl font-bold text-[#2d1c2b] sm:text-3xl"
            >
              {setContents.title}
            </h2>
            {setContents.subtitle && (
              <p className="mt-2 text-base text-[#4b3a2a]">
                {setContents.subtitle}
              </p>
            )}

            <ul className="mt-6 space-y-4">
              {items.map((item, index) => (
                <li
                  key={`${item.label}-${index}`}
                  className="flex gap-3 border-b border-[#f2bfd4] pb-4 last:border-b-0 last:pb-0"
                >
                  <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#ffe7f1] text-lg">
                    {item.icon || '*'}
                  </span>
                  <span className="text-base font-medium text-[#2d1c2b] sm:text-lg">
                    {item.label}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute -top-6 -right-6 h-24 w-24 rounded-full bg-[#ffd6e6] blur-2xl opacity-70" />
              <div className="rounded-3xl border-2 border-[#f2a1c4] bg-white p-3 shadow-[0_25px_45px_-30px_rgba(226,76,139,0.45)]">
                <ImageCarousel images={images} containerClassName="w-72 sm:w-80 lg:w-96 aspect-square" eagerIndex={-1} />
              </div>
              <div className="pointer-events-none absolute -bottom-8 left-1/2 h-12 w-44 -translate-x-1/2 rounded-full bg-[#f6c7db] blur-2xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrushSetDetails;


